import { Dropdown } from '@instinet-analytics/semantic-ui-components';

import './IndexEventsSideDropdown.css';

const AllSidesValue = 'all';

const options = [
    { value: AllSidesValue, text: 'All' },
    { value: 'buy', text: 'Buy' },
    { value: 'sell', text: 'Sell' },
];

const IndexEventsSideDropdown = ({
    side,
    onChangeSide: onChangeSideProps,
}: {
    side: string | undefined;
    onChangeSide: (nextSide: string | undefined) => void;
}) => {
    const value =
        side === undefined || side.trim() === '' ? AllSidesValue : side;

    const onChangeSide = (nextValue: string) => {
        const nextSide = nextValue === AllSidesValue ? undefined : nextValue;
        onChangeSideProps(nextSide);
    };

    return (
        <Dropdown
            className="IndexEventsSideDropdown"
            options={options}
            value={value}
            onChange={onChangeSide}
            placeholder={'All Sides'}
            inlineToolbar={true}
        />
    );
};

export default IndexEventsSideDropdown;
